"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class Auth extends base_1.default {
    getUser(id) {
        return this.get('/single-user', +id);
    }
    getUserAllData(id, guest = false) {
        let url = guest ? '/userAllData?guest=true' : '/userAllData';
        return this.get(url, { id });
    }
    deleteUser(data) {
        return this.delete('/user', data);
    }
    async updateUser(data, prop = '') {
        const userId = this.getStorageUser().id;
        const res = await this.put('/user/' + userId, data);
        this.updateAngularUser({ prop });
        return res;
    }
    updateAngularUser(prop = {}) {
        return window.AppearMe.Widgets.Events.emit('onUserUpdate', prop);
    }
    isUserAuthenticated() {
        return !localStorage.getItem('token');
    }
    getUserRole() {
        return this.getStorageUser().roleType;
    }
    getStorageUser() {
        return JSON.parse(localStorage.getItem('user'));
    }
    addUserState(data) {
        return this.post('/add-user-state', data);
    }
    checkBarNumber(data) {
        return this.get('/check-bar-number', data);
    }
    ifMailRegistered(email) {
        return this.post('/ifMailRegistered', { email });
    }
    updateUserDocs(data) {
        return this.post('/add-user-doc', data);
    }
    updatePracticeAreas(data) {
        return this.post('/add-practice-areas', data);
    }
    getUserHistory(data) {
        return this.post('/user-history/list', data);
    }
    getUserMoneyEntries() {
        return this.get('/user-history/total');
    }
}
exports.default = new Auth();
